import httpbaseURL from "../common/axios";
class RateContractService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/RateContract/Create", doc);
  }
  ratecontractmapping(doc) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.post(
      "/RateContractMappingMAP/Create",
      doc
    );
  }
  ratecontractmappingupdate(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/RateContractMappingMAP/Update",
      doc
    );
  }
  getdata(StoreId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/RateContract/ListCustom?StoreId=" + StoreId + ""
    );
  }
  //  GetTaxTable() {
  //     return httpbaseURL.httpMSInventoryUrl.get("/TaxMAS/TaxMasList")
  // }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get("/RateContract/Get?id=" + doc);
  }

  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/RateContract/Update", doc);
  }
  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/RateContract/Delete?id=" + doc
    );
  }

  //get items by rate contract id

  getitemsbyrateid(id, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/RateContract/GetItemsByRateContractId?Id=" +
        id +
        "&HospitalId=" +
        HospitalId
    );
  }

  getByItemId(id) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/RateContractMappingMAP/GetByItemId?Id=" + id
    );
  }
  deleteItems(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/RateContractMappingMAP/Delete?id=" + doc
    );
  }

  getitemsbySupplierIdStoreId(SupplierId, StoreId, HospitalId) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.get(
      "/RateContract/GetItemsBySupplierAndStoreId?SuplierId=" +
        SupplierId +
        "&StoreId=" +
        StoreId +
        "&HospitalId=" +
        HospitalId +
        ""
    );
  }
}
export default new RateContractService();
